module.exports = __webpack_public_path__ + "img/PNG.29d95720.png";